<template>
  <main role="main">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="page-con">
      <div class="page-list-con no-bn">
        <h2>{{ $t('HEADER.ACTIVITIES') }}</h2>
        <div v-if="isLoading" style="min-height:600px">
        </div>
        <div class="detailed-con" v-if="datas.length == 0 && !isLoading">
          <div class="oops">
              <img src="../../../static/images/10/oops.png" alt="">
          </div>
        </div>
        <ul class="col2-box">
          <li v-for="(item) in ShowData" :key="item.id">
            <a :href="'/activity/' + item.id" >
              <div class="page-list-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" ></div>
              <div>
                <h5>{{item.data.title}}</h5>
                <p class="time">{{item.data.date}} <i></i></p>
              </div>
            </a>
          </li>
        </ul>

        <Pagination :dataLength="datas.length" :rowPageCount="10" @start="getStart" @end="getEnd"></Pagination>
      </div>
    </div>
    <IndexFooter></IndexFooter>
  </main>
</template>
<script>
import {fb, db } from '../../firebase'
export default {
  name: 'Activity',
  data () {
    return {
      datas:[],
      isLoading: false,
      fullPage: true,
      start:0,
      end:0
    }
  },
  computed: {
    ShowData: function () {
      return this.datas.slice(this.start-1, this.end-1);
    }
  },
  mounted () {
    this.Get();
  },
  methods: {
    Get(){
      var vm = this;
      // 取得列表
      this.isLoading = true;
      db.collection(this.$t('DB.ACTIVITY')).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              var data = {"id": doc.id, "data": doc.data()};
              
              this.datas.push(data);
          });
          this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);
          this.isLoading = false;
      }).catch((error) => {
          console.log("Error getting document:", error);
          this.isLoading = false;
      });
    },
    getStart(val){
        this.start = val;
    },
    getEnd(val){
        this.end = val;
    }
  }
}
</script>
<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}

</style>


// WEBPACK FOOTER //
// src/components/index/Activity.vue